import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Link from 'valuelink';
import { Input } from 'valuelink/tags';
import { TiLocationOutline } from 'react-icons/ti';
import { FaArrowLeft } from 'react-icons/fa';

import { RegularText, Text } from '../../components/common/Text';
import LoadingComponent from '../../components/common/LoadingComponent';
import StyledTappable from '../../components/common/StyledTappable';
import { debounce, fontSize } from '../../utils';
import { getMmiAddressSuggestions } from '../../services';

const OuterContainer = styled.div`
  display: flex;
  width: 100%;
  height: 90vh;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
  background: white;
  border-radius: 12px 12px 0 0;
  @media screen and (max-width: 440px) {
    height: 100svh;
    width: 100%;
  }
`;

const HeaderContainer = styled.div`
  z-index: 10;
  align-self: stretch;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
  padding: 0.875rem;
  border-radius: 12px 12px 0 0;
`;

const BackContainer = styled(StyledTappable)`
  margin-right: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  &.Tappable-active {
    opacity: 0.2;
  }
`;

const StyledArrow = styled(FaArrowLeft)`
  width: 0.875rem;
`;

const StyledInput = styled(Input)`
  flex: 1;
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0.75rem;
  padding-top: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 84px;
`;

const LocationContainer = styled(StyledTappable)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.5rem 0;
  margin: 0.5rem 0;
  border-bottom: 1px solid rgba(151, 151, 151, 0.3);
  flex-shrink: 0;
`;

const LocationIcon = styled(TiLocationOutline)`
  margin-right: 0.875rem;
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
`;

const LocationTextContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const LocationText = styled(Text)`
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
`;

const LocationSubText = styled(RegularText)`
  font-size: ${() => fontSize(0.875)};
  color: #666;
`;

const LocationSearchHeader = styled(Text)`
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  margin: 0.625rem 0;
`;

class AddressSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addressResults: [],
      defaultCities: [],
      searchText: '',
      searching: false,
    };
    this.debounceSearch = debounce((val) => this.searchAddress(val), 800);
  }

  componentDidMount = () => {
    // this.getDefaultCities();
  };

  componentDidUpdate = () => {
    document.querySelector('.address-search-input').focus();
  };

  searchAddress() {
    const { authToken } = this.props;
    if (this.state.searchText.trim() === '') {
      this.setState({
        searchResults: this.defaultCities,
        searching: false,
      });
      return;
    }
    this.setState({
      searching: true,
    });
    getMmiAddressSuggestions(this.state.searchText, authToken)
      .then((resp) => {
        const searchResults = resp;
        console.log(searchResults);
        this.setState({
          addressResults: searchResults,
          searching: false,
        });
      })
      .catch((err) => {
        this.setState({
          searchText: '',
        });
        console.log(err);
      });
  }

  selectAddress(ele) {
    const { onAddressSelect } = this.props;
    if (onAddressSelect && typeof onAddressSelect === 'function') {
      const result = {
        formattedAddress: ele.placeAddress,
        city: ele.addressTokens.city,
        location: {
          lat: () => ele.latitude,
          lng: () => ele.longitude,
        },
      };
      onAddressSelect(result);
    }
    // const attributionElement = document.querySelector('#google-attribution');
    // getAddressDetails(attributionElement, ele.placeId)
    //   .then(result => {
    //     if (onAddressSelect && typeof onAddressSelect === 'function') {
    //       onAddressSelect(result);
    //     }
    //   })
    //   .catch(err => {
    //     this.setState({
    //       searchText: '',
    //     });
    //     console.log(err);
    //   });
  }

  render() {
    const { addressResults, searchText, searching } = this.state;
    const { onClose } = this.props;
    const searchTextLink = Link.state(this, 'searchText').onChange((val) => {
      if (val.length >= 3) {
        this.debounceSearch(val);
      }
    });
    const renderAddress = (ele) => (
      <LocationContainer key={ele.eLoc} onTap={() => this.selectAddress(ele)}>
        <LocationIcon />
        <LocationTextContainer>
          <LocationText>{ele.placeName}</LocationText>
          <LocationSubText>{ele.placeAddress}</LocationSubText>
        </LocationTextContainer>
      </LocationContainer>
    );
    return (
      <OuterContainer>
        <HeaderContainer>
          <BackContainer onTap={onClose}>
            <StyledArrow />
          </BackContainer>
          <StyledInput
            tabIndex={-1}
            valueLink={searchTextLink}
            placeholder="Search your address"
            className="visit-input address-search-input"
            onClick={(e) => e.stopPropagation()}
          />
        </HeaderContainer>
        <BodyContainer>
          {searching ? (
            <LoadingComponent />
          ) : (
            <>
              {searchText.trim().length === 0 ? (
                <LocationSearchHeader>Search your address</LocationSearchHeader>
              ) : addressResults.length === 0 ? (
                <LocationSearchHeader>
                  No results found. Try a different search
                </LocationSearchHeader>
              ) : (
                addressResults.map(renderAddress)
              )}
            </>
          )}
        </BodyContainer>
        {/* <AttributionLogo id="google-attribution" src={googlePoweredLogo} /> */}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(AddressSearch);
